import { Editor } from '@hugerte/hugerte-react'
import templates from './tinymce/templates'
import tinymceConfigs from './tinymce/tinymceConfigs'
import { fileBrowser } from './tinymce/tinymceCallbakcs'
import { bool, func, number, string } from 'prop-types'
import Div from '@ui/layout/Div'
import Alert from '@ui/elements/Alert'

const HugerteType = ({
  error,
  height = 300,
  config = 'min',
  name = '',
  initialValue = '',
  onChange = () => { },
  cssClass = '',
  label = '',
  help = '',
  disabled = false,
  isRequired = false
}) => {
  const apiKey = 'a5vu0bjqqpwliuek0n5dphezkq34q44j9jz70kghsf9u8kyc'
  let currentEditor = false

  const handleEditorChange = (content) => {
    onChange(name, content)
  }

  return (
    <Div cssClass={`field ${cssClass}`}>
      {label && <label className={`label ${isRequired ? 'is-required' : ''}`} htmlFor={`input-${name}`}>{label}</label>}
      <Div cssClass="control">
        <Editor
          apiKey={apiKey}
          disabled={disabled}
          value={initialValue}
          plugins={tinymceConfigs[config].plugins}
          toolbar={tinymceConfigs[config].toolbar}
          init={{
            setup: editor => {
              currentEditor = editor
            },
            height,
            menubar: tinymceConfigs[config].menuBar,
            file_picker_callback: (callback, value, meta) => {
              fileBrowser(callback, value, meta, currentEditor)
            },
            templates,
            content_css: '/assets/dist/css/common-admin.css',
            language: 'fr_FR'
          }}
          onEditorChange={handleEditorChange}
          file
          id={`input-${name}`}
        />
      </Div>
      {help && <p className="help">{help}</p>}
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </Div>
  )
}

HugerteType.propTypes = {
  config: string,
  name: string,
  onChange: func,
  cssClass: string,
  disabled: bool,
  help: string,
  label: string,
  placeholder: string,
  initialValue: string,
  error: string,
  isRequired: bool,
  height: number
}

export default HugerteType
